import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-110" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-111" data-mp="et66b3l83k4x">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border-2 border-gold bg-steel p-8 shadow-2xl shadow-black/30 sm:p-12" data-id="element-112" data-mp="eur1mvfd373u">
          <span className="inline-flex rounded-full border border-gold bg-navy p-4 text-mineral" data-id="element-113" data-mp="sn6y1ddrc6vs">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-114" data-mp="xls07ickl0mv" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-white" data-id="element-115" data-mp="12gxjsaii237s">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-116" data-mp="25sgj7ht4qe2g">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging surgical
            instrumentation class this week.
          </p>
          <p className="mt-3 leading-relaxed text-muted" data-id="element-117" data-mp="1vu10o3864d4k">
            If you feel your students didn't respond better or the materials didn't save you hours of work:
          </p>
          <p className="mt-6 rounded-lg border border-gold/40 bg-navy px-5 py-4 text-lg font-extrabold text-mineral" data-id="element-118" data-mp="2oh3kdp86qjar">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-119" data-mp="2er24hkpzk76x">
            Because if this teacher ready doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}